export class CartEntry
{
  date:string;
  id:string;
  amount:number;
}
